import React from 'react'
import icons from './../../../utils/import.icons'
import mobileAndTabletCheck from './../../../utils/mobileCheck'

import {BubblesData as BData} from './bubbles-t1.data' 

let imageSize = ["100vw", "100vh"];
let barOffset = 0;
if (mobileAndTabletCheck() && window.innerHeight > window.innerWidth) {
  barOffset = 5;
  imageSize = ["calc(84vh * 1.77778)", "84vh"];
}

interface Billboards{
    billboard: any,
    array: any,
    bubbles: any
}

interface Props{
    amenity: any,
    angle: number,
    gallery: any,
    openGallery: any,
    show: boolean,
    leftOffset: number,
    zoom: number,
    topOffset: number
}

interface State{
    angle: number,
    pos: any,
    transition: boolean
}

class Billboards extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            angle: 0,
            pos: [],
            transition: false
        }
    }

    componentDidMount(){
        this.array = <div></div>
        this.bubbles = BData()
    }

    createBillboards = () => {

            this.array = []
            
            if(this.bubbles[this.props.angle].length > 0){
                
                this.billboard = <div></div>
                for(let i = 0; i < this.bubbles[this.props.angle].length; i++){
                    this.array.push(
                        <svg 
                    width={"100%"}
                    height={"100%"}
                    preserveAspectRatio="none"
                    viewBox="0 0 1920 1080"
                    style={{
                        overflow: 'hidden',
                        pointerEvents: 'none',
                        position: 'absolute'
                    }}>
                        <circle 
                            cx={this.bubbles[this.props.angle][i].verts[0][0]} 
                            cy={this.bubbles[this.props.angle][i].verts[0][1]} 
                            r="30" 
                            style = {{
                                fill:"rgba(242,121,33,.85)",
                                stroke:"rgba(255,255,255,.85)",
                                strokeWidth:1
                            }}
                        >

                        </circle>
                        <text 
                        x={this.bubbles[this.props.angle][i].verts[0][0] - 8} 
                        y={this.bubbles[this.props.angle][i].verts[0][1] + 5}
                        width="40"
                        height="40"
                        fontFamily="Montserrat Regular" 
                        fontSize={mobileAndTabletCheck() ? "2vw":"1vw"}
                        fill="white"
                        > {BData()[this.props.angle][i].name.split(" ")[1]} </text>
                    </svg>
                    )
            }
        } 
    }

    componentDidUpdate(prevProps: any){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 5;
            imageSize = ['calc(84% * 1.77778)', '84%'];
        }
        else {
          imageSize = ['100%', '100%'];
          barOffset = 0;
        }
  
        // TODO: check if this routine can be optimized
        
        if(!this.props.show){
            return
        } 
                
        if(prevProps.angle !== this.props.angle || prevProps.show !== this.props.show){
            //console.log(this.props)
            this.createBillboards();
            this.forceUpdate();        
        }
    }
  
    render() {
        return (
            <div
                style={{
                    pointerEvents: 'none',
                    width: imageSize[0],
                    height: imageSize[1],
                    transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc(' + barOffset + '% + ' + this.props.topOffset + '%))'
                }}
                className={this.props.show && !this.state.transition ? "billboards fade-in":"billboards fade-out"}
            >
                {this.array}
            </div>
            
        );
      
    }

}

export default Billboards